<template>
  <HubContainer id="monitoringToolsHub">

    <HubSection large icon="icon/hub/heartbeat.svg"
                :title="$t('advanced_navigation.heartbeat')"
                :description="$t('advanced_navigation.heartbeat_description')"
                :buttonAction="goToHeartBeat">
    </HubSection>

    <HubSection large icon="icon/hub/server-status.svg" v-if="atLeastSuperAdmin"
                :title="$t('advanced_navigation.servers_status')"
                :description="$t('advanced_navigation.servers_status_description')"
                :buttonAction="goToServerStatus">
    </HubSection>

    <HubSection large icon="icon/hub/external-pos.svg" v-if="atLeastSuperAdmin"
                :title="$t('advanced_navigation.tunnel_migration')"
                :description="$t('advanced_navigation.tunnel_migration_description')"
                :buttonAction="goToTunnelMigration">
    </HubSection>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "monitoringToolsHub",

    components: {HubSection, HubContainer},

    mounted() {
      this.$store.state.pageTitleTranslationKey = "advanced_navigation.monitoring_tools";
      this.$store.state.pageIcon = "/icon/nav/monitoring.svg";
    },

    computed: {
      atLeastSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
    },

    methods: {
      goToHeartBeat() {
        this.$router.push(this.$router.buildContext("/heartbeat"));
      },
      goToServerStatus() {
        this.$router.push(this.$router.buildContext("/server-status"));
      },
      goToTunnelMigration() {
        this.$router.push(this.$router.buildContext("/tunnel-migration"));
      }
    }
  }
</script>